import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHeart: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHeart"><Path d="M21.5 9.875C21.5 15.9844 12.7917 20.5 12 20.5C11.2083 20.5 2.5 15.9844 2.5 9.875C2.5 5.625 5.13889 3.5 7.77778 3.5C10.4167 3.5 12 5.09375 12 5.09375C12 5.09375 13.5833 3.5 16.2222 3.5C18.8611 3.5 21.5 5.625 21.5 9.875Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconHeart;
